(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["cart-template"]) return;
  try {
    

var products = [];
		var cart = []
var total_price = 0;
var price = 0



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !window.DesignMode) return;
  try {
    
let btn = $('button[id^="AddToCart"]')
let show = btn.data('anim_activate')
let type = btn.data('anim_type')
let delay = btn.data('anim_delay')
if (show == true){
	setInterval(function(){
		btn.animateCss(type,function(){
			btn.removeClass('animated').removeClass(type)
		})
	},delay*1000)
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
moment.locale("fr")

function addWeekdays(date, days) {
  date = moment(date); // use a clone
  while (days > 0) {
  	date = date.add(1, 'days');
    // decrease "days" only if it's a weekday.
    if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
    	days -= 1;
    }
}
return date;
}


let btn = $('#AddToCart-product-template')
let show = btn.data('anim_activate')
let type = btn.data('anim_type')
let delay = btn.data('anim_delay')
if (show == true){
	setInterval(function(){
		btn.animateCss(type,function(){
			btn.removeClass('animated').removeClass(type)
		})
	},delay*1000)
}

let watching_start = Math.floor(Math.random() * (50-10+1) + 10)
let watching_text_people_origin = $('#marketing_watching_nb_text').data('personnes')
let watching_text_text = $('#marketing_watching_nb_text').data('watchingtext')
if(watching_text_people_origin){
let watching_text_people = watching_text_people_origin.replace("[nb]",watching_start)

$('#marketing_watching_nb_text').html('<span class="marketing_watching_bold">'+watching_text_people+'</span> '+watching_text_text)

}
setInterval(function(){
	if (Math.random() < 0.5){
		if(watching_start >= 10){
			watching_start++ 
		}
		else{
			watching_start--
		}
	}
	else{
		if(watching_start <= 50){
			watching_start--
		}
		else{
			watching_start++
		}
	}
	if(watching_start<0){
		watching_start=-watching_start
	}
	if(watching_text_people_origin){
	watching_text_people = watching_text_people_origin.replace("[nb]",watching_start)
	$('#marketing_watching_nb_text').html('<span class="marketing_watching_bold">'+watching_text_people+'</span> '+watching_text_text)
	}
},5000)

let commands_start_text_bolded = $('#marketing_commands_text').data('bolded')
let commands_start_text = $('#marketing_commands_text').data('text')
let commands_start = Math.floor(Math.random() * (20-1+1) + 1)
if (commands_start_text_bolded){
commands_start_text_bolded_new = commands_start_text_bolded.replace('[nb]',commands_start)}
if (commands_start_text){
commands_start_text_new = commands_start_text.replace('[bold]','<span class="marketing_watching_bold">'+commands_start_text_bolded_new+'</span>')
$('#marketing_commands_text').html(commands_start_text_new)
}

setInterval(function(){
	if (Math.random() < 0.5){
		commands_start--                 
	}
	else{
		commands_start++
	}
	if(commands_start<0){
		commands_start=-commands_start
	}
if (commands_start_text_bolded){
	commands_start_text_bolded_new = commands_start_text_bolded.replace('[nb]',commands_start)
	commands_start_text_new = commands_start_text.replace('[bold]','<span class="marketing_watching_bold">'+commands_start_text_bolded_new+'</span>')
	$('#marketing_commands_text').html(commands_start_text_new)
}
},8000);

let marketing_shipping_day_text_question = $('#marketing_shipping_day_text').data('questiontext')
let marketing_shipping_day_text_timertext = $('#marketing_shipping_day_text').data('timertext')
let marketing_shipping_day_text_color = $('#marketing_shipping_day_text').data('color')

let marketing_shipping_day_min = $('#marketing_shipping_day_text').data('min')
let marketing_shipping_day_max = $('#marketing_shipping_day_text').data('max')



let arrAvg = arr => arr.reduce((a,b) => a + b, 0) / arr.length
let shipping_time = Math.round(arrAvg([marketing_shipping_day_min,marketing_shipping_day_max]))
let shipping_time_to = addWeekdays(moment(),shipping_time)
let shipping_time_text = shipping_time_to.format("dddd DD MMM")
 if(marketing_shipping_day_text_question){
	marketing_shipping_day_text_question = marketing_shipping_day_text_question.replace('[date]',shipping_time_text.charAt(0).toUpperCase() + shipping_time_text.substr(1))

$('#marketing_shipping_day_text').html('<span class="marketing_watching_bold">'+marketing_shipping_day_text_question+'</span>')
}
var countDownDate = moment().add(1,'d').hours(5).minutes(0).toDate()

var countDownOffer = moment().add(window.localStorage.getItem('timer_old')-Math.ceil(Math.abs(window.localStorage.getItem('timer_old_timestamp') - new Date().getTime())/1000),'s').toDate();

// Update the count down every 1 second
var x = setInterval(function() {

  // Get todays date and time
  var now = new Date().getTime();

  // Find the distance between now and the count down date
  var distance = countDownDate - now;
  var distanceOffer = countDownOffer - now;
  let distanceOfferOld = distanceOffer
  if (window.localStorage.getItem('countdown_old') == null){
  	window.localStorage.setItem('countdown_old',distanceOffer)
  }
  else{
//console.log(window.localStorage.getItem('countdown_old'),distanceOffer)
window.localStorage.setItem('countdown_old', distanceOffer)
distanceOffer = window.localStorage.getItem('countdown_old')

}

  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  var daysOffer = Math.floor(distanceOffer / (1000 * 60 * 60 * 24));
  var hoursOffer = Math.floor((distanceOffer % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutesOffer = Math.floor((distanceOffer % (1000 * 60 * 60)) / (1000 * 60));
  var secondsOffer = Math.floor((distanceOffer % (1000 * 60)) / 1000);
  if(marketing_shipping_day_text_timertext){
  marketing_shipping_day_text_timertext = marketing_shipping_day_text_timertext.replace('[date]','<span id="marketing_watching_date" style="color:' + marketing_shipping_day_text_color + ';font-weight:bold;" >'+(hours + "h " + minutes + "mins")+'</span>')
  $('#marketing_shipping_day_text').html('<span class="marketing_watching_bold">'+marketing_shipping_day_text_question+'</span> '+marketing_shipping_day_text_timertext)
  //$('#marketing_watching_date').html(hours + "h " + minutes + "mins")

}	
	let marketing_countdown_date_jours = $('#marketing_countdown_text').data('jours')
	let marketing_countdown_date_heures = $('#marketing_countdown_text').data('heures')
	let marketing_countdown_date_minutes = $('#marketing_countdown_text').data('minutes')
	let marketing_countdown_date_secondes = $('#marketing_countdown_text').data('secondes')
	let marketing_countdown_color = $('#marketing_countdown_text').data('color')
	let marketing_countdown_text = $('#marketing_countdown_text').data('text')
	if (marketing_countdown_text){
	marketing_countdown_text = marketing_countdown_text.replace('[timer]','<span style="color:'+ marketing_countdown_color +';font-weight:bold;">'+("0" + daysOffer).slice(-2)+" "+marketing_countdown_date_jours+" "+ ("0" + hoursOffer).slice(-2) + " "+marketing_countdown_date_heures+" " + ("0" + minutesOffer).slice(-2) + " "+marketing_countdown_date_minutes+" "+  ("0" + secondsOffer).slice(-2) + " "+marketing_countdown_date_secondes + "</span>");
	$('#marketing_countdown_text').html(marketing_countdown_text)
}

	let marketing_countdown_date_text = 'Plus que 00 jours 00 heures 00 minutes 00 secondes pour profiter';


  if (distance < 0) {
  	countDownDate = moment().add(1,'d').hours(5).minutes(0).toDate()
  	countDownOffer = moment().add(1,'d').hours(5).minutes(0).toDate()
  }
}, 1000);
                   
/*$(function(){
if($('#AddToCart-product-template').data('loaderon') == true){
	$('#AddToCart-product-template').click(function(){
		$("#AddToCart-product-template span").html('<center style="padding:0;background:none;"><div class="loader"></div></center>')
	})
}
})*/

  } catch(e) { console.error(e); }
})();

})();
